export const DEFAULT_SUBAREA_SORT = {
    field: 'landfillName',
    direction: -1,
};
